// extracted by mini-css-extract-plugin
export default {"footer":"SummaryDrawerFooter_footer__PWZSj"};